import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as markdown from '@attain-apps/fe/web/main/lib/markdown'

import type { Feature } from './feature'
import * as models from './models'

/**
 * Used to render links to DMS models in Markdown
 *
 * @see {@link markdown.Extension.register}
 */
export function registerMarkdownExtension(feature: Feature) {
  const currentChartId = feature.selectors.charts.project(
    charts =>
      // TODO: Temporary solution; we should pass the exact chartId we want.
      Object.keys(charts).find(
        chartId =>
          models.Chart.Entry.tryGet(chartId as models.Chart.Id) === 'current',
      ) as models.Chart.Id | undefined,
  )
  markdown.Extension.register(
    'org-chart',
    ({ body, properties: { name } }) => ({
      init: element => {
        ;(element as HTMLElement).onclick = () => {
          const chartId = currentChartId.asSignal()
          if (!chartId) {
            return
          }
          const [widgetRefId] = models.Chart.Id.getParts(chartId)
          feature.actions.propose.from(`AssistantProposal.Clicked`).dispatch({
            chartId: models.Chart.Id.from({ entry: 'proposed', widgetRefId }),
            data: models.Proposal.fromXml(body),
            source: 'assistant',
          })
        }
      },
      // NOTE: JSON.stringify ensures the results are quoted, which helps
      // prevent XSS, as well as just accidental improper formatting
      innerHtml: `<div class="atn-org-chart-proposal">
  <h5 class="atn-org-chart-proposal__header">Proposal</h5>
  <p class="atn-org-chart-proposal__name">${JSON.stringify(name)}</p>
</div>`,
      styles: `.atn-org-chart-proposal {
  border: solid 1px ${ds.color.Scale.SHADOW.darker};
  background: ${ds.color.Scale.SHADOW.lightest};
  color: ${ds.color.Scale.SHADOW.darkest};
  font-size: 13px;
  border-radius: 5px;
  padding: 5px 8px;
  margin: 15px 5px;
  text-align: center;
  cursor: pointer;
}

.atn-org-chart-proposal__header, .atn-org-chart-proposal__name {
  font-size: 13px;
}`,
    }),
  )
}
